import type { EventAssertion } from "@/entities/form-metadata";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";

const ANY_EVENT_NAME = "Any";

export function useEventFieldFocusTracking(): (
    relation: string | null | undefined,
    eventName: string | null | undefined,
    fieldName: EventAssertion | "YearRangeEnd",
) => { onFocus: () => void } {
    const track = useTrackSearchFormInteraction();

    return (relation, eventName, fieldName) => ({
        onFocus: () =>
            track(
                {
                    action: "focus",
                    ...(relation && { relation }),
                    lifeEvent: eventName || ANY_EVENT_NAME,
                    fieldName,
                },
                { dedup: true },
            ),
    });
}
